
export interface IEventArgsBase {
    source: any
}

export interface IProperyChangedArgs extends IEventArgsBase {
    property: string
}


export interface EventHook<T> {

    Subscribe: (callback: (params: T) => void) => void;

    Unsubscribe: (callback: (params: T) => void) => void;

    UnsubscribeAll: () => void
}

export class EventHookManager<T> {

    public eventHook: EventHook<T> =
        {
            Subscribe: (callback: (params: T) => void): void => {
                if (!this._handlers.includes(callback)) {
                    this._handlers.push(callback);
                }
            },

            Unsubscribe: (callback: (params: T) => void): void => {

                let index = this._handlers.indexOf(callback);
                if (index > -1) {
                    this._handlers.splice(index, 1);
                }
            },

            UnsubscribeAll: () => {
                this._handlers = [];
            }
        }


    public Fire = (params: T) => {
        //
        // Fire any PropertyChangedEventListeners
        //
        for (let cb of this._handlers) {
            if (cb) {
                cb(params);
            }
        }
    }

    private _handlers: ((params: T) => void)[] = [];
}